import React from "react";

import Breadcrumb from "../components/Breadcrumb";
import ChatView from "../components/ChatView";

const ChatViewPage = () => {
  return (
    <>
      <ChatView />
    </>
  );
};

export default ChatViewPage;
